export default __webpack_public_path__ + "4eddbd841a5a5c79cabe19a1c03f668e.png";